import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-status-chd",
  "use": "icon-status-chd-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-status-chd\"><path d=\"M896 405.333333v128c0 106.026667-171.946667 192-384 192s-384-85.973333-384-192v-128c0 106.026667 171.946667 192 384 192s384-85.973333 384-192z m-768 213.333334c0 106.026667 171.946667 192 384 192s384-85.973333 384-192v128c0 106.026667-171.946667 192-384 192s-384-85.973333-384-192v-128z m384-106.666667c-212.053333 0-384-85.973333-384-192S299.946667 128 512 128s384 85.973333 384 192-171.946667 192-384 192z\" p-id=\"2103\" fill=\"#56bcc0\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/status-chd.svg
// module id = z/7b
// module chunks = 111